"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getClassNames = utilities_1.memoizeFunction(function (styles, className) {
    return {
        root: styling_1.mergeStyles("dashboard-add", styles.root, className),
        editor: styling_1.mergeStyles("dashboard-add-editor", styles.editor),
        actions: styling_1.mergeStyles("dashboard-add-actions", styles.actions),
        action: styling_1.mergeStyles("dasboard-add-action", styles.action)
    };
});
exports.getClassNames = getClassNames;
